<template>
  <v-container>
    <v-row justify="center" align="baseline" v-scroll="onScroll">
      <v-icon :color="color" @click="scrollToTop" large>{{ icon }}</v-icon>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TciScroll",
  props: {
    icon: String,
    color: String,
    text: String
  },
  data: () => ({
    offsetTop: 0,
  }),
  methods: {
    scrollToTop: function(){
      this.$vuetify.goTo(0,{duration: 1000,easing:'easeInOutCubic'})
    },
    onScroll: function(e){
      this.offsetTop = e.target.scrollTop
    }
  }
};
</script>
